<app-loader *ngIf="authLoading || ADFSLoading"></app-loader>
<div *ngIf="!ADFSLoading">
  <div class="modal__header">
    <span class="title">Вход в {{ Enums.projectName }}</span>
    <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appInputCancelX"></div>
  </div>
  <div class="modal__body">
    <form [formGroup]="authForm">
      <div class="mt-4">
        <app-field>
          <label>Логин</label>
          <input class="input-text" type="text" formControlName="login" id="login" />
        </app-field>
      </div>
      <div class="mt-8">
        <app-field-password>
          <label>Пароль</label>
          <input class="input-text" type="password" formControlName="password" id="password" />
        </app-field-password>
      </div>
    </form>
    <div class="mt-16" *ngIf="authError">
      <app-message [type]="'error'">
        <div message-content>{{ authError }}</div>
      </app-message>
    </div>
  </div>
  <div class="modal__footer">
    <div class="modal__footer-action">
      <button class="button" type="button" (click)="onSubmitAuthForm()" [disabled]="!authForm.valid" id="appInputSubmit">Войти</button>
    </div>
    <div class="modal__footer-action">
      <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appInputCancel"> отмена </a>
    </div>
  </div>
</div>
